import React, { FC } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

export const PageBankAccountsStatementsRedirect: FC = () => {
  const { search, hash } = useLocation();
  return <Navigate to={{ pathname: '../activity', search, hash }} replace />;
};
